/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".custom-img[_ngcontent-%COMP%]{overflow-x:auto;overflow-y:auto;max-height:400px}"];
export { styles as styles };

